import React from "react";

function Header() {
    return (
        <div className="Header">
            Get your salary distribution automated!
        </div>
    );
}

export default Header;